import { FSCollections } from '@src/constants/database';
import { API_OPERATIONS } from '@src/util/cloud-functions/operations';

import IntlMessages from '@src/util/IntlMessages';

import { DASHBOARDS_FORMS } from '../../../constants';
import { renderPieChartContent } from '../renderers/pieChartRenderer';
import { transformPieChartData } from '../transformers/pieChartTransformer';

import type { WidgetConfig } from './types';

export const pieChartConfig: WidgetConfig = {
  collectionName: FSCollections.PIE_CHARTS,
  componentType: DASHBOARDS_FORMS.EVENT_COUNTER,
  op: API_OPERATIONS.EVENTS_COUNTER,

  buildParams: (queryParams, commonParams) => ({
    ...commonParams,
    formIds: [queryParams.formId],
    eventTypes: queryParams.eventIds,
  }),

  transformData: transformPieChartData,
  renderContent: renderPieChartContent,

  getSubTitle: ({ data }) => {
    if (!data) return null;
    return (
      <IntlMessages
        id="dashboards.chart.totalEvents"
        values={{ total: data.info?.totalEvents || 0 }}
      />
    );
  },
};
